import { z } from "zod";
import { GNOME_SPINE_EMOTES } from "../../logic/helpers/gnomeSpineBody";
import { GNOME_EMOTE_OCCASIONS } from "../../logic/helpers/gnomeEmoteVariety";
import { GnomeEquippedItemIdsSchema } from "./GnomeCustomizationSliceSchema";

const EmoteSchema = z.enum(GNOME_SPINE_EMOTES);
export const GnomeCareerAppearanceSchema = z.object({
    equipment: GnomeEquippedItemIdsSchema,
    skinColorId: z.string(),
});

/** App-session presentation memory only; it grants no rewards or ownership. */
export const GnomeCareerPresentationSliceSchema = z.object({
    dismissedCareerCompletionKey: z.string().nullable().default(null),
    emoteHistory: z.object({
        recent: z.array(EmoteSchema).max(8),
        lastByOccasion: z.partialRecord(
            z.enum(GNOME_EMOTE_OCCASIONS),
            EmoteSchema,
        ),
    }),
    observedAppearance: GnomeCareerAppearanceSchema.nullable(),
    observedOwnedItemCodes: z.array(z.string()).nullable(),
    pendingEarnedItemCodes: z.array(z.string()),
});

export type GnomeCareerAppearance = z.infer<typeof GnomeCareerAppearanceSchema>;
export type GnomeCareerPresentationSlice = z.infer<
    typeof GnomeCareerPresentationSliceSchema
>;
